'use client';

import { useCookieConsent } from '@/app/contexts/cookie-consent-context';

interface ConsentReopenerProps {
  type?: 'externalMedia' | 'analytics';
  className?: string;
}

export default function ConsentReopener({ type = 'externalMedia', className = '' }: ConsentReopenerProps) {
  const { consent, setShowConsentManager } = useCookieConsent();

  // If consent is already given for the specified type, don't show the reopener
  if (consent[type]) {
    return null;
  }

  return (
    <div className={`p-4 rounded-md ${className}`} 
         style={{ 
           backgroundColor: 'var(--secondary)', 
           color: 'var(--foreground)',
           border: '1px solid var(--foreground)'
         }}>
      <div className="flex flex-col items-center text-center">
        <h3 className="text-lg font-medium mb-2" style={{ color: 'var(--foreground)' }}>
          {type === 'externalMedia' ? 'Karten sind deaktiviert' : 'Analyse ist deaktiviert'}
        </h3>
        <p className="text-sm mb-4" style={{ color: 'var(--foreground)' }}>
          {type === 'externalMedia'
            ? 'Um Karten auf unserer Website anzuzeigen, müssen Sie in Ihren Cookie-Einstellungen Cookies für externe Medien aktivieren.'
            : 'Um uns bei der Verbesserung unserer Website zu helfen, können Sie in Ihren Cookie-Einstellungen Analyse-Cookies aktivieren.'}
        </p>
        <button
          onClick={() => setShowConsentManager(true)}
          className="px-4 py-2 text-sm font-medium rounded-md"
          style={{ 
            backgroundColor: 'var(--primary)', 
            color: '#000000'
          }}
        >
            Cookie Einstellungen aktualisieren
        </button>
      </div>
    </div>
  );
}
